<template>
  <div>
    <h1>Директора ДО</h1>
    <h4 v-if="isFetching">Загрузка...</h4>
    <div class="row g-3">
      <div class="col-md-3">
        <label for="regionGroupSelect" class="form-label">БИН</label>
        <input type="text" @change="fetchKindergartenHeads(true)" class="form-control" id="username" v-model="searchParam.username" />
      </div>
      <div class="col-md-3">
        <label for="regionGroupSelect" class="form-label">ИИН Директорв</label>
        <input type="text" @change="fetchKindergartenHeads(true)" class="form-control" id="username" v-model="searchParam.iin" />
      </div>
    </div>
    <b-pagination v-model="currentPage" :total-rows="pageResponse?.totalElements" :per-page="searchParam.perPage"></b-pagination>

    <button class="open-modal-btn" @click="openModal">Добавить директора ДО</button>

    <table v-if="kindergartenHeads.length > 0" class="kindergartenAllowance-heads-table">
      <thead>
      <tr>
        <th>ID</th>
        <th>Имя</th>
        <th>Фамилия</th>
        <th>Username</th>
        <th>ИИН</th>
        <th>LMS ID</th>
        <th>БИН ДО</th>
        <th>Название ДО</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="head in kindergartenHeads" :key="safeUserInfoId(head.userInfo)">
        <td>{{ head.userInfo.id }}</td>
        <td>{{ head.userInfo.firstName }}</td>
        <td>{{ head.userInfo.lastName }}</td>
        <td>
          <router-link :to="`/kindergarten/head/${head.userInfo.id}`" class="username-link">
            {{ head.userInfo.username }}
          </router-link>
        </td>
        <td>{{ head.userInfo.userAttributes[UserAttribute.IIN] }}</td>
        <td>{{ head.lmsSystem?.lmsId ?? 'N/A' }}</td>
        <td>{{ head.lmsSystem?.kindergartenDocumentInfo?.bin ?? 'N/A' }}</td>
        <td>{{ head.lmsSystem?.kindergartenDocumentInfo?.name ?? 'N/A' }}</td>
      </tr>
      </tbody>
    </table>

    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <h2>Добавить директора ДО</h2>
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="firstName">Имя:</label>
            <input type="text" id="firstName" v-model="firstName" required />
          </div>

          <div class="form-group">
            <label for="lastName">Фамилия:</label>
            <input type="text" id="lastName" v-model="lastName" required />
          </div>

          <div class="form-group">
            <label for="username">Имя пользователя:</label>
            <input type="text" id="username" v-model="username" required />
          </div>

          <div class="form-group">
            <label for="iin">ИИН:</label>
            <input type="text" id="iin" v-model="iin" required />
          </div>

          <div class="form-group">
            <label for="lmsId">LMS система:</label>
            <multiselect
              v-model="selectedLms"
              :options="lmsSystems"
              label="lmsId"
              placeholder="Выберите LMS систему"
              :searchable="true"
              :clear-on-select="true"
              :close-on-select="true"
              :allow-empty="true"
            />
          </div>

          <button type="submit" class="submit-btn" :disabled="isLoading">
            {{ isLoading ? 'Создание...' : 'Создать' }}
          </button>
        </form>
        <button class="close-modal-btn" @click="closeModal">Закрыть</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, reactive, ref, watch} from "vue";
import { getLmsSystems } from "@/services/directoryService";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import {LmsSystemItem} from "@/types/kindergarten";
import { UserInfoDTO, KindergartenHeadItem } from "@/types/user";
import { createUser, findAllKindergartenHeads } from "@/services/userService";
import {PageResponse} from "@/types/pageResponse";
import {UserRoles, UserAttribute} from "@/contants";
import {SearchParam} from "@/types/searchParam";

export default defineComponent({
  computed: {
    UserAttribute() {
      return UserAttribute
    }
  },
  components: {
    Multiselect
  },
  setup() {
    const searchParam = reactive({
        username: "",
        iin: "",
        perPage: 10,
        page: 1
    });
    const showModal = ref(false);
    const firstName = ref("");
    const lastName = ref("");
    const username = ref("");
    const iin = ref("");
    const selectedLms = ref<LmsSystemItem | null>(null);
    const isLoading = ref(false);
    const lmsSystems = ref<LmsSystemItem[]>([]);
    const pageResponse = ref<PageResponse<KindergartenHeadItem>>();
    const kindergartenHeads = ref<KindergartenHeadItem[]>([]);
    const currentPage = ref(1);
    const page = ref(1);
    const pageSize = ref(10);
    const isFetching = ref(false);

    const openModal = () => {
      showModal.value = true;
    };

    const closeModal = () => {
      showModal.value = false;
      firstName.value = "";
      lastName.value = "";
      username.value = "";
      iin.value = "";
      selectedLms.value = null;
    };

    const fetchLmsSystems = async () => {
      try {
        const token = localStorage.getItem("access_token");
        if (token) {
          lmsSystems.value = await getLmsSystems(token);
        }
      } catch (error) {
        console.error("Ошибка при получении данных:", error);
      }
    }

    const fetchKindergartenHeadsInfos = async (isPageDefault: boolean = false) => {
      try {
        isFetching.value = true;
        if (isPageDefault) {
          searchParam.page = 1;
          currentPage.value = 1;

        }
        const token = localStorage.getItem("access_token");
        if (token) {
          const filter: Record<string, any> = {};
          filter["role"] = UserRoles.ROLE_DO_HEAD;
          if(searchParam.username && searchParam.username.length >= 1) {
            filter["username"] = searchParam.username;
          }
          if (searchParam.iin && searchParam.iin.length >= 1) {
            filter["iin"] = searchParam.iin;
          }
          const searchParams = new SearchParam(
              searchParam.perPage,
              searchParam.page,
              filter,
              {}
          );
          pageResponse.value = await findAllKindergartenHeads(token, searchParams);
          kindergartenHeads.value = pageResponse.value.content;
        }
        isFetching.value = false;
      } catch (error) {
        isFetching.value = false;
        console.error("Ошибка при получении данных:", error);
      }
    }

    const handleSubmit = async () => {
      isLoading.value = true;

      try {
        const token = localStorage.getItem("access_token");
        if (token && selectedLms.value && 'id' in selectedLms.value) {
          const lmsSystem: LmsSystemItem = selectedLms.value;
          const userAttributes: Record<string, string> = {};
          userAttributes[UserAttribute.LMS_ID] = lmsSystem.lmsId;
          userAttributes[UserAttribute.IIN] = iin.value;
          const directorData: UserInfoDTO = {
            id: null,
            email: null,
            firstName: firstName.value,
            lastName: lastName.value,
            username: username.value,
            enabled: true,
            role: UserRoles.ROLE_DO_HEAD,
            userAttributes: userAttributes
          };
          await createUser(token, directorData).then(() => {
            fetchKindergartenHeadsInfos();
          });
        }

        closeModal();
      } catch (error) {
        console.error("Ошибка при создании директора ДО:", error);
      } finally {
        isLoading.value = false;
      }
    };

    const safeUserInfoId = function(userInfo: UserInfoDTO) {
      return userInfo?.id || 'default-id';
    };

    onMounted(() => {
      fetchKindergartenHeadsInfos();
      fetchLmsSystems();
    });

    watch(currentPage, (newPage) => {
      searchParam.page = newPage;
      fetchKindergartenHeadsInfos()
    });

    return {
      showModal,
      firstName,
      lastName,
      username,
      iin,
      selectedLms,
      isLoading,
      lmsSystems,
      kindergartenHeads,
      currentPage,
      pageResponse,
      openModal,
      closeModal,
      handleSubmit,
      fetchKindergartenHeads: fetchKindergartenHeadsInfos,
      safeUserInfoId,
      searchParam,
      isFetching,
    };
  },
});
</script>

<style scoped>
h1 {
  text-align: center;
  margin-top: 20px;
}

.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h2, h4 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049;
}

.close-modal-btn {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.close-modal-btn:hover {
  background-color: #e31b0c;
}

.kindergartenAllowance-heads-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.kindergartenAllowance-heads-table th,
.kindergartenAllowance-heads-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.kindergartenAllowance-heads-table th {
  background-color: #4CAF50;
  color: white;
}
</style>